import React from "react";
import "./ChristmasTree.css";

const ChristmasTree = () => {
    return (
        <div className="xmas-tree">
            <div className="xmas-tree__star">★</div>
            <div className="xmas-tree__top"></div>
            <div className="xmas-tree__middle"></div>
            <div className="xmas-tree__bottom"></div>
            <div className="xmas-tree__trunk"></div>
            <div className="xmas-tree__ornament xmas-tree__ornament--1"></div>
            <div className="xmas-tree__ornament xmas-tree__ornament--2"></div>
            <div className="xmas-tree__ornament xmas-tree__ornament--3"></div>
            <div className="xmas-tree__ornament xmas-tree__ornament--4"></div>
            <div className="xmas-tree__ornament xmas-tree__ornament--5"></div>
            <div className="xmas-tree__ornament xmas-tree__ornament--6"></div>
        </div>
    );
};

export default ChristmasTree;
